import React from "react";
import styles from "./AuditTrail.module.css";
import AuditCollection from "./components/AuditCollection";

const AuditTrail = ({ setPage, setPageTitle }) => {
  setPage("auditTrail");
  setPageTitle("Audit Trail");
  
  return (
    <div className={styles.alarmLogs}>
      <div className={styles.wrapper}>
        <div className={styles.bodywrapper}>
          <AuditCollection />
        </div>
      </div>
    </div>
  );
};

export default AuditTrail;
